export default __webpack_public_path__ + "static/media/nap3.ea91b47e.png";